import { render } from "./AppEditorPanel.vue?vue&type=template&id=4a99e38e&ts=true"
import script from "./AppEditorPanel.vue?vue&type=script&lang=ts"
export * from "./AppEditorPanel.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/mj-root/fe-site-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__